import i18next from 'i18next';

i18next.addResources('es', 'navbar', {
  title: 'Base de datos de Proyectos y Acciones',
  home: 'Inicio',
  projects: 'Proyectos y Acciones',
  maps: 'Mapa',
  territories: 'Proyectos y Acciones por Territorio',
  charts: 'Analíticas',
  logout: 'Cerrar sesión'
});

i18next.addResources('en', 'navbar', {
  title: 'Projects and Actions database',
  home: 'Home',
  projects: 'Projects and Actions',
  maps: 'Map',
  territories: 'Projects and Actions by Territory',
  charts: 'Analytics',
  logout: 'Log out'
});

i18next.addResources('pt', 'navbar', {
  title: 'Base de dados de Projetos e Ações',
  home: 'Início',
  projects: 'Projetos e Ações',
  maps: 'Mapa',
  territories: 'Projetos e Ações por Território',
  charts: 'Análise',
  logout: 'Sair'
});
